import React, { useState, useEffect, useContext } from "react";
import { 
    Grid,
    IconButton,
    Tooltip,
    Button,
    CircularProgress,
    Typography,
    Dialog,
    DialogActions,
    DialogTitle
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import {
    AddCircle,
    
} from '@material-ui/icons';
import axios from "axios";
import { AppContext } from '../../context/AppContext';
  
const Briefs = () => {
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [data, setData] = useState(undefined);
    const [selectedOrg, setSelectedOrg] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const appCtx = useContext(AppContext);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [briefId, setBriefId] = useState()

    const fetchData = async () => {
        setLoading(true);

        axios.get('briefs').catch((e) => {
            setLoading(false);
            console.log(`failed to get briefs with error`, e);
            appCtx.setAlert({ type: 'error', message: e?.data?.message ?? 'Failed to get briefs' });
        }).then(result => {
            if (result?.data?.response) {
                let responseData = result.data.response.sort((a, b) => {
                    return a.created_at > b.created_at ? -1 : 1
                })
                setData(responseData);
                // console.log('look here', result.data.response.filter(r => r.deleted === 0))
            } else {
                setData(undefined);
            }
    
            setLoading(false);
        });
        
    };

    const showDeleteBrief = (id) => {
        setBriefId(id)
        setShowConfirmDelete(true)
    }

    const deleteBrief = async (id) => {
        setShowConfirmDelete(false)
        axios.post('delete-brief', {id: id}).catch((e) => {
            console.log(`failed to delete brief with error`, e);
            appCtx.setAlert({ type: 'error', message: e?.data?.message ?? 'Failed to delete brief' });
        }).then(result => {
            if (result?.data) {
                appCtx.setAlert({ type: 'success', message: 'Deleted Brief' });
                fetchData()
            } else {
                console.error(`failed to delete brief`);
            }
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    const viewBrief = (brief) => {
        window.open(`https://briefs.sympler.co/brief/view?h=${brief.hash}`, '_blank')
    }

    let briefs = [];
    if (data) {
        briefs = data.map((b) => [
            (<Button onClick={() => viewBrief(b)}>{b.briefName}</Button>),
            // (<Typography>{b.briefName}</Typography>),
            // (<Typography>{b.org_name}</Typography>),
            (<Button onClick={() => viewBrief(b)}>{b.name}</Button>),
            (<Button onClick={() => viewBrief(b)}>{b.org_name}</Button>),
            (<Typography>{b.created_at}</Typography>),
            (<Button onClick={() => showDeleteBrief(b.id)}>Delete</Button>),
        ]);
    }

    return (
        <>
            <Dialog open={showConfirmDelete}>
                <DialogTitle>
                    <Typography>Are you sure you want to delete this brief?</Typography>
                </DialogTitle>
                <DialogActions>
                    <Button onClick={() => setShowConfirmDelete(false)}>Cancel</Button>
                    <Button onClick={() => deleteBrief(briefId)}>OK</Button>
                </DialogActions>
            </Dialog>
            <Grid container spacing={4} justify="center" alignItems="center">
                {loading && (
                    <Grid item>
                        <CircularProgress />
                    </Grid>
                )}
                {!loading && (
                    <Grid item xs={12}>
                        <MUIDataTable
                            title="Briefs"
                            data={briefs}
                            columns={["Brief Name", "User Name", "Org Name", "Date Submitted", "Delete"]}
                            // columns={[{name: "Name"}, {name: "Org Name"}, {name: "Date Submitted", options: {sort: true}},]}
                            options={{
                                download: false,
                                print: false,
                                filter: false,
                                sort: false,
                                search: false,
                                viewColumns: false,
                                selectableRows: 'none',
                                pagination: false,
                                // onRowClick: (rowData, rowMeta) => {
                                //     if (data) {
                                //         viewBrief(data[rowMeta.rowIndex]);
                                //     }
                                // },
                                // customToolbar: () => {
                                //     return (
                                //         <React.Fragment>
                                //             <Tooltip title="Add Organization">
                                //                 <IconButton onClick={toggleModal}>
                                //                     <AddCircle />
                                //                 </IconButton>
                                //             </Tooltip>
                                //         </React.Fragment>
                                //     );
                                // }
                            }}
                        />
                    </Grid>
                )}
            </Grid>
        </>
    );
};
export default Briefs;